import styled from 'styled-components';
export const VideoRatio16By9 = styled.div.withConfig({
  displayName: "UiVideoPlayerstyles__VideoRatio16By9",
  componentId: "sc-u8ome1-0"
})(["background-color:rgba(0,0,0,0.25);padding:56.25% 0 0 0;position:relative;overflow:hidden;"]);
export const ResponsiveVideoWrapper = styled.div.withConfig({
  displayName: "UiVideoPlayerstyles__ResponsiveVideoWrapper",
  componentId: "sc-u8ome1-1"
})(["height:100%;left:0;position:absolute;top:0;width:100%;"]);
export const ResponsiveVideoFrame = styled.iframe.withConfig({
  displayName: "UiVideoPlayerstyles__ResponsiveVideoFrame",
  componentId: "sc-u8ome1-2"
})(["height:100%;left:0;position:absolute;top:0;width:100%;"]);
export const VideoEmbed = styled.div.withConfig({
  displayName: "UiVideoPlayerstyles__VideoEmbed",
  componentId: "sc-u8ome1-3"
})(["width:100%;height:100%;"]);